<template>
	<div
		v-if="show"
		class="general-popup-overlay"
		role="dialog"
		aria-modal="true"
	>
		<div class="general-popup">
			<div class="general-popup__body">
				<span class="general-popup__message">{{ message }}</span>
			</div>
			<div class="general-popup__actions">
				<button
					type="button"
					class="general-popup__btn general-popup__btn--primary"
					@click.prevent="$emit('yes')"
				>
					{{ positiveLabel }}
				</button>
				<button
					type="button"
					class="general-popup__btn general-popup__btn--primary"
					@click.prevent="$emit('no')"
				>
					{{ negativeLabel }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'GeneralPopup',

	props: {
		show: {
			type: Boolean,
			required: true,
		},
		message: {
			type: String,
			required: true,
		},
		negativeLabel: {
			type: String,
			default: 'No',
		},
		positiveLabel: {
			type: String,
			default: 'Yes',
		},
	},
}
</script>

<style scoped>
.general-popup-overlay {
	align-items: center;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	inset: 0;
	justify-content: center;
	position: fixed;
	z-index: 10050;
}

.general-popup {
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
	max-width: 90vw;
	padding: 10px 20px 8px;
	text-align: center;
	width: 350px;
}

.general-popup__body {
	color: #2d3748;
	font-family: 'Roboto', sans-serif;
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 8px;
	margin-top: 10px;
	text-align: center;
}

.general-popup__message {
	display: inline-block;
	line-height: 1.4;
}

.general-popup__actions {
	display: flex;
	gap: 10px;
	justify-content: center;
	padding: 10px 0 20px;
}

.general-popup__btn {
	border: none;
	border-radius: 4px;
	cursor: pointer;
	flex: 1;
	font-family: 'Roboto', sans-serif;
	font-size: 14px;
	font-weight: 500;
	min-height: 35px;
	max-width: 120px;
	padding: 0 15px;
	transition: background-color 0.2s ease, color 0.2s ease,
		border-color 0.2s ease;
}

.general-popup__btn--primary {
	background-color: #805ad5;
	color: #fff;
}

.general-popup__btn--primary:hover {
	background-color: #6b46c1;
}

.general-popup__btn--secondary {
	background-color: #fff;
	border: 1px solid #cbd5e0;
	color: #2d3748;
}

.general-popup__btn--secondary:hover {
	background-color: #f7fafc;
	border-color: #a0aec0;
}
</style>
